export const guestEventMessages = {
  overlap: {
    ko: '이미 등록된 일정과 겹칩니다.',
    en: 'This overlaps with an existing event.',
    fr: 'Cela chevauche un événement existant.'
  },
  capacity: {
    ko: '이 시간대는 이미 3개의 예약이 있어 추가할 수 없습니다.',
    en: 'This time slot already has 3 reservations.',
    fr: 'Ce créneau a déjà 3 réservations.'
  },
  blockedDay: {
    ko: '이 날짜는 금지일로 설정되어 있습니다.',
    en: 'This date is blocked.',
    fr: 'Cette date est bloquee.'
  },
  outsideGuestPeriodCreate: {
    ko: '이벤트는 게스트 기간 내에만 생성할 수 있습니다.',
    en: 'Events can only be created within your guest period.',
    fr: 'Les événements ne peuvent être créés que pendant votre période d\'invité.'
  },
  outsideGuestPeriodUpdate: {
    ko: '이벤트는 게스트 기간 내에만 수정할 수 있습니다.',
    en: 'Events can only be modified within your guest period.',
    fr: 'Les événements ne peuvent être modifiés que pendant votre période d\'invité.'
  },
  invalidEventTime: {
    ko: '이벤트 시간 형식이 올바르지 않습니다.',
    en: 'The event time format is invalid.',
    fr: 'Le format horaire de l\'événement est invalide.'
  }
};

export function getGuestMessage(lang, key, fallbackKey = key) {
  return guestEventMessages[key]?.[lang]
    || guestEventMessages[fallbackKey]?.[lang]
    || guestEventMessages[fallbackKey]?.ko
    || guestEventMessages[key]?.ko
    || '';
}

export function getGuestEventApiErrorMessage(lang, errorCode, fallbackMessage, options = {}) {
  const {
    outsideGuestPeriodKey = 'outsideGuestPeriodUpdate'
  } = options;

  if (errorCode === 'EVENT_OVERLAPS_EXISTING_GUEST_EVENT') {
    return getGuestMessage(lang, 'overlap');
  }

  if (errorCode === 'EVENT_OUTSIDE_GUEST_PERIOD') {
    return getGuestMessage(lang, outsideGuestPeriodKey);
  }

  if (errorCode === 'EVENT_ON_GUEST_BLOCKED_DAY') {
    return getGuestMessage(lang, 'blockedDay');
  }

  if (errorCode === 'EVENT_EXCEEDS_GUEST_CONCURRENT_LIMIT') {
    return getGuestMessage(lang, 'capacity');
  }

  if (errorCode === 'INVALID_EVENT_TIME') {
    return getGuestMessage(lang, 'invalidEventTime');
  }

  return fallbackMessage;
}
